import { ResourceRef } from 'api/types';
import { action, makeObservable, observable } from 'mobx';
import { CacheStoreInterface } from './types';

export class FileCacheStore implements CacheStoreInterface {
    @observable public cachedResources: Map<ResourceRef['id'], string> = new Map();

    public constructor() {
        makeObservable(this);
    }

    @action
    public addCachedFile(fileId: ResourceRef['id'], fileData: string) {
        this.cachedResources.set(fileId, fileData);
    }

    @action
    public deleteCachedFiles() {
        this.cachedResources = new Map();
    }

    @observable
    public get(id: ResourceRef['id']): string | undefined {
        return this.cachedResources.get(id);
    }
}

export const fileCacheStore = new FileCacheStore();
